import type { RouteRecordRaw } from 'vue-router';
import { useAdminNavStore } from '@/modules/admin/stores/admin-nav';
import { navItems } from './nav';

const setNavItems = () => {
  const store = useAdminNavStore();
  store.navItems = navItems;
};

export const adminPrayerTalksListRoute: RouteRecordRaw = {
  path: `/admin/prayer-talks`,
  name: 'adminPrayerTalksList',
  redirect: {
    name: 'prayerTalks',
  },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminPrayerTalksRoute: RouteRecordRaw = {
  path: `/admin/prayer-talks/prayer-talks`,
  component: () => import('@/modules/admin-prayer-talks/views/PrayerTalks.vue'),
  name: 'prayerTalks',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminPrayerTalkSlidesRoute: RouteRecordRaw = {
  path: `/admin/prayer-talks/slides`,
  component: () => import('@/modules/admin-prayer-talks/views/PrayerTalkSlides.vue'),
  name: 'prayerTalkSlides',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminPrayerTalkVideosRoute: RouteRecordRaw = {
  path: `/admin/prayer-talks/videos`,
  component: () => import('@/modules/admin-prayer-talks/views/BackgroundVideos.vue'),
  name: 'prayerTalkVideos',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};

export const adminPrayerTalkAudioRoute: RouteRecordRaw = {
  path: `/admin/prayer-talks/audio`,
  component: () => import('@/modules/admin-prayer-talks/views/BackgroundAudio.vue'),
  name: 'prayerTalkAudio',
  beforeEnter: () => { setNavItems(); },
  meta: {
    layout: 'admin-sidebar',
  },
};
